<template>
  <div style="background-color: #f4fbff; height: 100vh">
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="false"
    >
    </Header>
    <div class="login">
      <div class="login-wrap">
        <div class="login_id-pass">
          <div class="login_input-box two-fac">
            <p class="login_two-fac_title">メールアドレス入力</p>
            <p class="login_two-fac_ex">
              パスワード変更には認証が必要なため、メールアドレスを介し認証コードを送信します
            </p>

            <div class="login_two-fac_select">
              <p id="login_two-fac_input-name">メールアドレス</p>
              <input
                type="email"
                id="two-fac_input"
                name="name"
                required
                value
                v-model="formData.mail"
              />
            </div>
          </div>
          <van-button
            :disabled="!this.formData.mail"
            block
            :color="!this.formData.mail ? '#AACBE7' : '#48b2fb'"
            type="primary"
            native-type="submit"
            :loading="loading"
            @click="handleSure"
            id="pwd_btn_lost"
            >送信する</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {SendVerifyCode} from "@/services/user";
  import {Toast} from "vant";
  import "vant/es/toast/style";
  import Janus from "@/assets/js/janus";
  import Header from "@/components/Header.vue";

  export default {
  data() {
    return {
      password: "",
      user: JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY)),
      formData: {},
      loading: false,
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.formData.id = this.user.id;
  },
  methods: {
    onClickLeft() {
      history.back();
    },
    handleSure() {
      this.loading = true;
      const detail = this.formData;
      SendVerifyCode(detail).then((res) => {
        if (res.data.code >= 0) {
          this.$router.push({
            path: "/userLostPassCode",
            query: {
              mail: this.formData.mail
            },
          });
          if (Janus) {
            Janus.videoPageDestory();
          }
        } else {
          Toast.fail("メールボックスエラー");
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style scoped>
   
   
  

#pwd_btn_lost {
  width: 100%;
  height: 54px;
  background: #aacbe7;
  border-radius: 8px;
  color: #fff;
  display: block;
  font-size: 20px;
  line-height: 54px;
  text-align: center;
  margin-top: auto;
}
#pwd_btn_lost.possible {
  background: #3b82c4;
  pointer-events: auto;
}
</style>
